<template>
  <div>
    <div class="md-layout">
      <h3 class="md-layout-item title font-medium text-2xl">
        {{ $t("common.my_profile") }}
      </h3>
    </div>
    <student-profile
      v-if="hasValidRole(this.role, Role.Student)"
    ></student-profile>
    <staff-profile v-else></staff-profile>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Role from "@/constants/Role";
import { hasValidRole } from "@/helpers/role-helper";
import StaffProfile from "./StaffProfile";
import StudentProfile from "./StudentProfile";

export default {
  data() {
    return {
      Role,
      hasValidRole
    };
  },
  components: { StudentProfile, StaffProfile },
  computed: {
    ...mapGetters("user", ["role"])
  }
};
</script>
